import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import CardLongTitle from "./CardLongTitle";
import LongReadMoreContent from "./LongReadMoreContent";

const CardLongTextContainer = ({
  title,
  excerpt = "",
  fullContent = "",
  ctas,
  enableReadMore = true,
  scrollToTop = () => {}
}) => {
  const [fontSize, setFontSize] = useState({ title: "20px", text: "16px" });

  // Update styles based on screen size
  const updateStyles = () => {
    if (window.innerWidth <= 768) {
      setFontSize({ title: "18px", text: "14px" });
    } else {
      setFontSize({ title: "20px", text: "16px" });
    }
  };

  // Update styles on resize
  useEffect(() => {
    updateStyles();
    window.addEventListener("resize", updateStyles);
    return () => window.removeEventListener("resize", updateStyles);
  }, []);

  return (
    <div>
      <CardLongTitle title={title} />
      <div className="card__excerpt" style={{ fontSize: fontSize.text }}>
        {excerpt}
      </div>
      <LongReadMoreContent
        fullContent={fullContent}
        floatDirection=""
        ctas={ctas}
        enableReadMore={enableReadMore}
        scrollToTop={scrollToTop}
      />
    </div>
  );
};

CardLongTextContainer.propTypes = {
  title: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  fullContent: PropTypes.node.isRequired,
  ctas: PropTypes.array.isRequired,
  enableReadMore: PropTypes.bool.isRequired,
  scrollToTop: PropTypes.func.isRequired
};

export default Object.assign(CardLongTextContainer, {
  Title: CardLongTitle,
  excerpt: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  fullContent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
});
